export const pageTransitionDuration = 0.9;

// Shared easing curve used across page transitions, the first-load loader,
// and any other entrance animation that should feel consistent with them.
export const CUSTOM_EASE = [0.65, 0.05, 0, 1];

export function calculateDelay(animationOrder = 0, index = 1, delay = 0) {
  const firstBlockDelay = 0.5;

  const delayMultiplier = 0.3;

  return (
    delayMultiplier * animationOrder +
    (index === 0 ? firstBlockDelay : 0) +
    delay
  );
}

// rootMargin for one-shot scroll-entrance triggers (`useInView(..., { once: true })`).
// Order is top right bottom left. The negative *bottom* shrinks the root's
// bottom edge, so an element must be ~10% of the viewport height above the fold
// before it counts as in view — late enough that a multi-second stagger doesn't
// play out off-screen.
//
// Do not move that negative value to the *top* slot: a negative top shrinks the
// root's top edge instead, and anything sitting entirely within that top band
// (a hero eyebrow under a fixed header, the first block on a page too short to
// scroll) never intersects, so with `once: true` it never reveals at all.
export const REVEAL_MARGIN = '0px 0px -10% 0px';
